const values = [
  "icon_alchemist_skill_acidsplash",
  "icon_alchemist_skill_catbot",
  "icon_angelwings_skill_angelicwrath",
  "icon_angelwings_skill_celestialbeam",
  "icon_arrowtower_skill_criticalstrike",
  "icon_avalanchesurfer_skill_boulderdash",
  "icon_avalanchesurfer_skill_earthward",
  "icon_avalanchesurfer_skill_quake",
  "icon_axemantower_skill_noescape",
  "icon_barracks_skill_parry",
  "icon_bearchief_skill_ancestralleadership",
  "icon_bearchief_skill_ferociousroar",
  "icon_bearchief_skill_logroll",
  "icon_beemistress_infectiousvenom",
  "icon_beemistress_queenbee",
  "icon_beemistress_venomousstinger",
  "icon_beemistress_warmhoney",
  "icon_beetletower_skill_infestation",
  "icon_beetlewarrior_skill01",
  "icon_beetlewarrior_skill02",
  "icon_beetlewarrior_skill03",
  "icon_beetlewarrior_skill05",
  "icon_blastrune_skill_blastforce",
  "icon_bolt_skill_aftershock",
  "icon_breathoffire_skill_motherofdragons",
  "icon_castthebones_skill_goodomens",
  "icon_castthebones_skill_lucky7",
  "icon_castthebones_skill_signsandportents",
  "icon_centaurarcher_bola",
  "icon_centaurarcher_serratedarrow",
  "icon_centaurarcher_warhall",
  "icon_centaurbarracks_skill_charge",
  "icon_chosen_skill_smite",
  "icon_cloudrabbit_bunnyhop",
  "icon_cloudrabbit_capriciouswaters",
  "icon_cloudrabbit_cloudcover",
  "icon_cloudrabbit_hailstorm",
  "icon_cloudtower_skill_refreshingrain",
  "icon_cloudviking_skill_chillingdefense",
  "icon_cloudviking_skill_flyingaxes",
  "icon_cloudviking_skill_frostcleave",
  "icon_cloudviking_skill_shatteredshield",
  "icon_crusader_skill_divinemight",
  "icon_darksummons_skill_doomguard",
  "icon_deathknight_skill_deathbolt",
  "icon_deathknight_skill_grave_slash",
  "icon_deathknight_skill_raisedead",
  "icon_desecrate_skill_boneprison",
  "icon_divinedommand_skill_brillianthalo",
  "icon_divinedommand_skill_dyinglight",
  "icon_divinedommand_skill_holyaura",
  "icon_dragoonbarracks_skill_bolster",
  "icon_dwarfsmith_skill_flameturret",
  "icon_dwarfsmith_skill_hammercrash",
  "icon_dwarfsmith_skill_ignite",
  "icon_dwarfsmith_skill_towersmith",
  "icon_dynastinae_skill_broodemergence",
  "icon_dynastinae_skill_trample",
  "icon_dynastinae_skill_violentemergence",
  "icon_enhancement_upgrade_01",
  "icon_enhancement_upgrade_02",
  "icon_enhancement_upgrade_03",
  "icon_evilwings_skill_cursefullfilment",
  "icon_fireball_skill_bounce",
  "icon_flamegoddess_calderadefense",
  "icon_flamegoddess_flamecharge",
  "icon_flamegoddess_rocketsmash",
  "icon_flamegoddess_vulcanfist",
  "icon_flamethrower_skill_billowsweep",
  "icon_flamethrower_skill_firedevil",
  "icon_flamethrower_skill_oilgrenade",
  "icon_flamethrower_skill_rocketfist",
  "icon_foreseer_skill_crystalball",
  "icon_foreseer_skill_foreshadowing",
  "icon_foreseer_skill_fortuneteller",
  "icon_frozenvoyage_skill_drakarbreath",
  "icon_frozenvoyage_skill_onfrozenwinds",
  "icon_frozenvoyage_skill_raidingparty",
  "icon_fungalbloom_skill_colonybloom",
  "icon_giftofkinahau_skill_sizzlingflare",
  "icon_goblinchef_skill_secret_ingredient",
  "icon_goblinchef_skill_secret_spicysoup",
  "icon_goblinchef_skill_special_delivery",
  "icon_hercules_crushingblow",
  "icon_hercules_demigodsmight",
  "icon_hercules_heaveho",
  "icon_icemage_skill_blizzard",
  "icon_icemage_skill_frostbolt",
  "icon_icemage_skill_icearmor",
  "icon_icemage_skill_supernova",
  "icon_iceman_skill_brotherlylove",
  "icon_judgement_skill_needlesoflight",
  "icon_lavaooze_skill_subdivide",
  "icon_lionking_firebrand",
  "icon_lionking_roaringflame",
  "icon_lionking_tomyhand",
  "icon_magmafall_skill_magmapools",
  "icon_magmafall_skill_reflux",
  "icon_manastorm_skill_essenseofmagic",
  "icon_manastorm_skill_manasurge",
  "icon_mark_skill_power",
  "icon_merfolkfighter_skill_anchorwhirl",
  "icon_merfolkfighter_skill_hookshot",
  "icon_mermantower_skill_bubblecage",
  "icon_mermantower_skill_tempestcaller",
  "icon_mightofyaoga_skill_greatspirit",
  "icon_passability_bg_dark",
  "icon_passability_bg_fire",
  "icon_passability_bg_ice",
  "icon_passability_bg_light",
  "icon_passability_bg_locked",
  "icon_passability_bg_nature",
  "icon_passability_bg_normal",
  "icon_passive_ability_frame",
  "icon_passive_ability_mask01",
  "icon_passive_ability_mask02",
  "icon_planttower_skill_circleoflife",
  "icon_polybomb_skill_upgrade",
  "icon_ramhammer_skill_batteringram",
  "icon_ramhammer_skill_funneledmight",
  "icon_ramhammer_skill_ramaltar",
  "icon_reaper_skill_grimspectre",
  "icon_reaper_skill_headswillroll",
  "icon_reaper_skill_spectralscythe",
  "icon_reinforce_skill_resolve",
  "icon_reinforce_skill_royalguard",
  "icon_reinforce_skill_spearthrow",
  "icon_ronin_skill_dash",
  "icon_ronin_skill_execute",
  "icon_ronin_skill_hiddenstrike",
  "icon_ronin_skill_shurikens",
  "icon_salvo_skill_mine",
  "icon_sandscorpion_bladedance",
  "icon_sandscorpion_eternalservice",
  "icon_sandscorpion_paralyticvenom",
  "icon_sandscorpion_swelteringsunlight",
  "icon_scorcher_skill_embersoul",
  "icon_skill_affinity_power_blue",
  "icon_skill_affinity_power_brown",
  "icon_skill_affinity_power_gold",
  "icon_skill_affinity_power_green",
  "icon_skill_affinity_power_purple",
  "icon_skill_affinity_power_red",
  "icon_skill_affinity_resist_blue",
  "icon_skill_affinity_resist_brown",
  "icon_skill_affinity_resist_gold",
  "icon_skill_affinity_resist_green",
  "icon_skill_affinity_resist_purple",
  "icon_skill_affinity_resist_red",
  "icon_skill_atkup",
  "icon_skill_awaken",
  "icon_skill_blind",
  "icon_skill_burn",
  "icon_skill_charm",
  "icon_skill_chill",
  "icon_skill_chill_upgrade",
  "icon_skill_curse",
  "icon_skill_daze",
  "icon_skill_defenseup",
  "icon_skill_doom",
  "icon_skill_dragoon_slayer",
  "icon_skill_dragoon_whirlwind",
  "icon_skill_fear",
  "icon_skill_freeze",
  "icon_skill_gears",
  "icon_skill_haunted",
  "icon_skill_healing",
  "icon_skill_healing_upgrade",
  "icon_skill_heroic_charge",
  "icon_skill_heroic_ultimatespell",
  "icon_skill_hpup",
  "icon_skill_iceelemental",
  "icon_skill_knockback",
  "icon_skill_manaorb",
  "icon_skill_mark",
  "icon_skill_packleader",
  "icon_skill_polymorph",
  "icon_skill_power_bleed",
  "icon_skill_power_burn",
  "icon_skill_power_chill",
  "icon_skill_power_polymorph",
  "icon_skill_power_polymorph_root",
  "icon_skill_root",
  "icon_skill_seared",
  "icon_skill_shadowburn",
  "icon_skill_shield",
  "icon_skill_shield_upgrade",
  "icon_skill_shiftaffinity_blue",
  "icon_skill_shiftaffinity_brown",
  "icon_skill_shiftaffinity_gold",
  "icon_skill_shiftaffinity_green",
  "icon_skill_shiftaffinity_purple",
  "icon_skill_shiftaffinity_red",
  "icon_skill_ship_anchor",
  "icon_skill_silence",
  "icon_skill_slow",
  "icon_skill_soulburn",
  "icon_skill_soul_soak",
  "icon_skill_spell_cooldown",
  "icon_skill_spell_cost",
  "icon_skill_stun",
  "icon_skill_sunder",
  "icon_skill_towerbuff",
  "icon_skill_tower_blue",
  "icon_skill_tower_brown",
  "icon_skill_tower_gold",
  "icon_skill_tower_green",
  "icon_skill_tower_purple",
  "icon_skill_tower_red",
  "icon_skill_toxic",
  "icon_skill_vigor",
  "icon_skill_wolfpack",
  "icon_spikedbarricade_skill_pitfall",
  "icon_stoneguard_skill_cleave",
  "icon_summontreants_skill_bramblebirth",
  "icon_sunsanctum_skill_starburst",
  "icon_teslatower_skill_conductivefield",
  "icon_toadshaman_skill_quick_tongue",
  "icon_toadshaman_skill_slimebomb",
  "icon_toadshaman_skill_tadpole_rush",
  "icon_typhoon_skill_depthcharge",
  "icon_vinelash_skill_overgrowth",
  "icon_warbots_skill_megabot",
  "icon_warbots_skill_planb",
  "icon_warlocktower_skill_bloodsacrifice",
  "icon_windknight_skill_determination",
  "icon_windknight_skill_windslash",
  "icon_windknight_skill_windwarriors",
  "icon_yeti_skill_bodyslam",
  "icon_yeti_skill_frigidbelch",
  "icon_yeti_skill_mightyhunger",
  "icon_yeti_skill_yetiyelp",
  "icon_tag_aoe",
  "icon_tag_assassin",
  "icon_tag_beast",
  "icon_tag_bg",
  "icon_tag_bg2",
  "icon_tag_boar",
  "icon_tag_boss",
  "icon_tag_buff",
  "icon_tag_caster",
  "icon_tag_changeaffinity",
  "icon_tag_chargehero",
  "icon_tag_cheap",
  "icon_tag_colossal",
  "icon_tag_corrupted",
  "icon_tag_coward",
  "icon_tag_crowdcontrol",
  "icon_tag_damageamplification",
  "icon_tag_debuff",
  "icon_tag_elite",
  "icon_tag_execute",
  "icon_tag_flying",
  "icon_tag_gearincome",
  "icon_tag_globalability",
  "icon_tag_goblin",
  "icon_tag_healing",
  "icon_tag_heavyarmor",
  "icon_tag_Illusionist",
  "icon_tag_lasting",
  "icon_tag_living",
  "icon_tag_melee",
  "icon_tag_metamorphosis",
  "icon_tag_ranged",
  "icon_tag_sheilded",
  "icon_tag_spirit",
  "icon_tag_stealth",
  "icon_tag_summoner",
  "icon_tag_tank",
  "icon_tag_teleport",
  "icon_tag_undead",
  "icon_attack_per_sec",
  "icon_attribute_cooldown",
  "icon_attribute_defensive",
  "icon_attribute_disable",
  "icon_attribute_manacost",
  "icon_attribute_offensive",
  "icon_attribute_price",
  "icon_attribute_speed",
  "icon_attribute_support",
  "icon_damage_per_sec",
  "icon_defense",
  "icon_disable",
  "icon_hitpoint",
  "icon_offense",
  "icon_range",
  "icon_respawn_time",
  "icon_speed",
  "icon_splash_radius",
  "icon_stop",
  "icon_support",
  "icon_target",
  "icon_troop_count",
];
export default values;
